const CVDRiskLevel = Object.freeze({
  RC1: "Low Risk",
  RC2: "Moderate Risk",
  RC3: "High Risk",
  RC4: "Very High Risk"
})

export default CVDRiskLevel;